import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_budget_category_attachment_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  category_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  file_name: fromDatatype.VarcharDatatypeInterface;
  import_format: fromDatatype.VarcharDatatypeInterface;
  file_size: fromDatatype.NumericDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  image_category: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  error_message: fromDatatype.TextDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_budget_category_attachment_RowClass
  implements bl_fi_budget_category_attachment_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  category_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  file_name: fromDatatype.VarcharDatatypeInterface;
  import_format: fromDatatype.VarcharDatatypeInterface;
  file_size: fromDatatype.NumericDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  image_category: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  error_message: fromDatatype.TextDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
